import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import CheckoutForm from "./CheckoutForm";
import { useSubscription } from "../../auth/Subscription";
import { Redirect } from "react-router";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

const Subscribe = () => {
  const [subscription] = useSubscription();

  if (subscription.type === "active") {
    return <Redirect to="/settings/subscription" />;
  }

  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm />
    </Elements>
  );
};

export default Subscribe;
